module.exports = __webpack_public_path__ + "img/视频封面28.32b2bba3.png";